import React, { useContext, useEffect, useState } from "react";
import {
  COLLEGE_UUID,
  customSorting,
  groupByMultiple,
  upperCase,
} from "../../utils";
import { COURSE_TYPE_SORT_ORDER_LAW } from "../../utils/data";
import { _ListCourseSubjects } from "../../models/subjectModel";
import { Col, Row, Table } from "react-bootstrap";
import LoadCourseList from "./loadCourseList";
import PsContext from "../../context";

const OldQuestionPaper = () => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [selectedType, setSelectedType] = useState([]);
  const [selectedTypeKey, setSelectedTypeKey] = useState(null);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    setSelectedType([]);
    setSelectedTypeKey(null);
    _ListCourseSubjects({
      college_uuid: COLLEGE_UUID,
    }).then((res) => {
      if (res.status == "1") {
        let re = customSorting(res.data, ["regular", "self"], "coursetype");
        re = customSorting(re, COURSE_TYPE_SORT_ORDER_LAW, "course_type");

        let d = groupByMultiple(re, function (obj) {
          return [obj.academic_dept_type, obj.coursetype];
        });
        setDataList(d);
      } else {
        setDataList([]);
      }
      setLoader(false);
    });
  };

  const handleRowClick = (data, key) => {
    if (selectedTypeKey == key) {
      setSelectedType([]);
      setSelectedTypeKey(null);
    } else {
      setSelectedType(data);
      setSelectedTypeKey(key);
    }
  };

  return (
    <div>
      <div className="container com-sp pad-bot-70 pg-inn ps_min_height px-5">
        <Row>
          <Col md={12}>
            <h5
              style={{
                color: `${context.settingValue("web_site_header_textcolor")}`,
              }}
            >
              Old Question Papers
            </h5>
            <hr />
          </Col>
        </Row>
        <div style={{ minHeight: "250px" }}>
          <Table size="sm" bordered className="table-hover">
            <tbody>
              {dataList.map((item, i) => {
                return (
                  <tr key={i}>
                    <td>
                      <div
                        className="p-2 cursor-pointer"
                        onClick={(e) => handleRowClick(item, i)}
                      >
                        <b>
                          {upperCase(item[0].course_level_name)}-
                          {upperCase(
                            item[0].coursetype == "regular"
                              ? "AIDED"
                              : "UNAIDED"
                          )}
                        </b>
                        <span
                          className="float-end"
                          style={{
                            color: `${context.settingValue(
                              "web_site_header_textcolor"
                            )}`,
                          }}
                        >
                          {selectedTypeKey == i ? (
                            <i className="fa-solid fa-chevron-up"></i>
                          ) : (
                            <i className="fa-solid fa-chevron-down"></i>
                          )}
                        </span>
                      </div>
                      {selectedTypeKey == i && (
                        <LoadCourseList item={item[0]} />
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default OldQuestionPaper;
